class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    document.addEventListener('algolia.autocomplete.stateChange', (event) => {
      const { isOpen, previousIsOpen } = event.detail;
      if (isOpen == false && previousIsOpen == true) {
        if (document.querySelector('.aa-DetachedOverlay') == null && window.innerWidth < 1024) {
          this.close();
        }
      }
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const eventTarget = event.target;
    /* if eventTarget is an SVG or part of an SVG, then find closest parent that is not an SVG */
    if (eventTarget.closest('svg')) {
      const closestSvg = eventTarget.closest('svg');
      const closestSvgParent = closestSvg.parentElement;

      if (closestSvgParent.classList.value.includes('aa-') && window.innerWidth < 1024) return;
    }

    if (
      event.target.classList.value.includes('aa-') &&
      window.innerWidth < 1024 &&
      !event.target.classList.value.includes('aa-DetachedCancelButton')
    )
      return;
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    document.querySelector('sticky-header').classList.add('active');
    document.querySelector('.header').classList.add('active');

    if (this.detailsContainer.querySelector('input:not([type="hidden"])') === null) {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('button.aa-DetachedSearchButton'),
      );
      this.detailsContainer.querySelector('button.aa-DetachedSearchButton').focus();
      this.detailsContainer.querySelector('button.aa-DetachedSearchButton').click();
    } else {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])'),
      );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.querySelector('.header').classList.remove('active');
    document.querySelector('sticky-header').classList.remove('is-fixed');
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.dispatchEvent(new CustomEvent('details-modal:close'));
  }
}

customElements.define('details-modal', DetailsModal);
